<cms-hotspots-wrapper class="w-12 pos-relative"
                      [component]="component"
                      [targetUrl]="component.cta_link || ''">
    <div class="image-component overflow-hidden"
         [class]="[component.ratio || '']">
        <local-shell />
        <img class="rf"
             [image]="component.image">
        @if (component.blocks && component.blocks.length) {
        <div class="fill flex">
            <div class="flex"
                 [class]="[((component.width) ? component.width : 'w-12')]">
                <div class="w-12 pos-relative">
                    <!-- blocks -->
                    @for (block of component.blocks; track $index) {
                    <div class="pos-absolute right-0"
                         [class]="['z-' + $index, block.style || '', (block.custom ? 'left-0' : '')]"
                         [style.top.%]="(block.top_position || 0)"
                         [style.left.%]="(block.custom ? 0 : block.left_position || 0)"
                         [style.right.%]="(block.custom ? 0 : block.right_position || 0)">

                        @if (block.custom) {
                        <icms-outlet [components]=" block.components" />
                        } @else {
                        @for (line of block.lines; track $index) {
                        @switch (line.type) {
                        @case ('text') {
                        <tag [tag]="line.tag">
                            <span class="w-12"
                                  [class]="[line.align||'', line.text_style|| 'h4', line.color||'', line.style||'']"
                                  *iCms="'text' of line"></span>
                        </tag>
                        }
                        @case ('button') {
                        <div class="p-t-2 p-b-2"
                             [class]="[line.align||'', line.form_size||'', line.style||'']">
                            <a [class]="((line.button_class) ? line.button_class : '')"
                               [routerLink]="line.button_link || component.cta_link">
                                <span class="button__body"
                                      *iCms="'text' of line"
                                      [class]="line.button_class === 'button-inline' ? '' + line.color : ''"></span>
                            </a>
                        </div>
                        }
                        }
                        }
                        }
                    </div>
                    }
                </div>
            </div>
        </div>
        }
    </div>
</cms-hotspots-wrapper>